import React, { useState } from "react";
import { X, Lock } from "lucide-react";
import {auth} from "./firebase";
import { signInWithEmailAndPassword, getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";

function Login({ onLogin, onBack, onForgotPassword }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const cleanEmail = email.trim().toLowerCase();
    const cleanPassword = password.trim();
    const auth = getAuth();

    setError("");
    setLoading(true);

    if (!cleanEmail || !cleanPassword) {
      alert("Please fill in both fields.");
      setLoading(false);
      return;
    }
    console.log("Logged In");
    try {
      //set to forces the tab close = logout behavior
      await setPersistence(auth, browserSessionPersistence);
      
      //verify with password
      await signInWithEmailAndPassword(auth,cleanEmail,cleanPassword);
      
      //notify parent (welcome.js -> parent.js)
      if (onLogin) onLogin();

    } catch (err) {
      console.error("Login error:", err);

      //clean up firebase error messages
      let msg = "Login failed. Please try again.";
      if (err.code === "auth/invalid-credential") msg = "Incorrect email or password.";
      if (err.code === "auth/user-not-found") msg = "No account found with this email.";
      if (err.code === "auth/wrong-password") msg = "Incorrect password.";
      if (err.code === "auth/too-many-requests") msg = "Too many attempts. Try again later.";
      
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    // ✨ POPUP MODAL WRAPPER
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
      
      {/* Modal Card */}
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md mx-4 p-8 relative animate-slideUp">
        
        <button
          onClick={onBack}
          className="absolute top-5 right-5 text-gray-400 hover:text-gray-600 transition-colors bg-gray-100 p-2 rounded-full hover:bg-gray-200"
        >
          <X size={20} />
        </button>

        {/* Icon */}
        <div className="mx-auto h-16 w-16 rounded-2xl bg-[#FFF3E0] flex items-center justify-center mb-6">
          <Lock className="w-8 h-8 text-[#EA580C]" />
        </div>

        <h2 className="text-3xl font-extrabold text-center text-[#5A3E2B] mb-8">
          Welcome Back
        </h2>

        {error && (
          <div className="bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm text-center mb-4 border border-red-100">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="text-[#5A3E2B] font-bold text-sm ml-1">Email</label>
            <input
              type="email"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#EA580C] focus:border-transparent outline-none transition-all"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label className="text-[#5A3E2B] font-bold text-sm ml-1">Password</label>
            <input
              type="password"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#EA580C] focus:border-transparent outline-none transition-all"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {/* Forgot Password */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onForgotPassword}
              className="text-sm text-[#FF8C42] hover:underline font-medium"
            >
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl bg-[#FF8C42] text-white font-bold shadow-lg hover:shadow-xl 
                       hover:scale-[1.01] transition-all
                       disabled:opacity-70"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
